
import $ from 'jquery';
import {View} from 'backbone';
import constants from 'Constants';

class ModalView extends View {

    initialize(){

        $('body').append(this.$el);
        this.settings = {
            autoOpen: true,
            dialogClass: "no-close",
            height: "auto",
            width: this.width || 'auto',
            modal: true,
            resizable: false,
            buttons: []
        };

        this.isRendered = false;
    }

    render(id){
        //Don't forget to fill the $el with your own template before triggering this render
        //this.$el.html(template(this.model.toJSON()));
        const modalId = id || constants.DIALOG_ID;

        $( modalId ).dialog(this.settings);
        $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

        // One-shot ESC handler
        ( ctx => {
            ctx.isRendered = true;
            const escHandler = e => {
                // ESCAPE key pressed
                if (e.keyCode === 27) {
                    $(document).off("keydown", escHandler);
                    ctx.closeModal();
                }
            };
            $(document).on("keydown", escHandler);
        })(this);
    }

    // Please ensure any extending  class calls this method, or provides ESC logic in any override
    closeModal(id){

        if (this.isRendered) {
            const modalId = id || constants.DIALOG_ID;
            this.isRendered = false;
            $(modalId).dialog("destroy");
            this.remove();
        }
    }
}

export default ModalView;